/**
 * Modelo de los datos que se reciben desde los chasis de los
 * canales App y Web para Aprobados en Firme.
 * {
 *  offerId - Id de la oferta
 *  offerType - Tipo de la oferta (En_firme)
 * }
 */
export class SpecialOfferModel {
  offerId: string;
  offerType: string;
}

// tslint:disable-next-line
export class DetailProductSpecialOffer {
  brand: string;
  product_type: string;
  limit_amount: {
    currency: string,
    amount: number,
    decimals: number,
  };
  term: number;
}
